import {skin} from "../utils/Skin.js";

export class Window {

	/**
	 *
	 * @param {function|string} titleBuilder
	 * @param {function} contentBuilder
	 */
	constructor(titleBuilder, contentBuilder, icon, windowClass) {
		this.titleBuilder = titleBuilder;
		this.contentBuilder = contentBuilder;
		this.icon = icon;
		this.x = 100;
		this.y = 100;
		this.closed = true;
		this.windowClass = windowClass;
	}

	getBody() {
		return this.wbody;
	}

	/**
	 * Register close callback
	 * @param {function} callback
	 */
	setCloseCallback(callback) {
		this.closeCallback = callback;
	}

	open(show = true) {
		if (!this.closed) return;
		this.w = $("<div class='window' style='display:none'></div>");
		if (this.windowClass) this.w.addClass(this.windowClass);
		this.wtitle = $("<div class='window-title'></div>");
		this.wtitleLeft = $("<span class='window-title-left'></span>");
		this.wtitleRight = $("<span class='window-title-right'></span>");
		const closeIcn = $(Icon.fi("close", null, "cursor:pointer"));
		this.wtitleRight.append(closeIcn);
		this.wtitle.append(this.wtitleLeft);
		this.wtitle.append(this.wtitleRight);
		this.wbody = $("<div class='window-body'></div>");
		this.w.append(this.wtitle);
		this.w.append(this.wbody);
		$("body").append(this.w);
		this.wtitle.on("mousedown",  this.dragStart.bind(this));
		closeIcn.on("click",  this.close.bind(this));

		if (typeof this.titleBuilder === 'string') this.wtitleLeft.text(this.titleBuilder);
		else if (typeof this.titleBuilder === 'function') {
			const data = this.titleBuilder(this.wtitleLeft.get(0));
			if (typeof data === 'string') this.wtitleLeft.text(data);
		}

		if (this.contentBuilder != null) {
			if (typeof this.contentBuilder === 'string') this.wbody.html(this.contentBuilder);
			else if (typeof this.contentBuilder === 'function') {
				const data = this.contentBuilder(this.wbody.get(0));	// pass element for the case that builder wants to append content directly
				if (typeof data === 'string') this.wbody.html(data);
			}
		}

		if (this.icon) {
			const itag = skin.iconTag(this.icon, null);
			itag.css("margin-right", "4px");
			this.wtitleLeft.prepend(itag);
		}
		this.position();
		if (show) this.show();
		this.closed = false;
	}

	show() {
		this.w.show();
	}

	position() {
		this.w.css("left", this.x + "px");
		this.w.css("top", this.y + "px");
	}

	dragStart(e) {
		this.startMouseX = e.clientX;
		this.startMouseY = e.clientY;
		this.startX = this.x;
		this.startY = this.y;
		$(document).on("mousemove.wdrag", this.drag.bind(this));
		$(document).on("mouseup.wdrag", this.dragEnd.bind(this));
		this.w.css("opacity", "0.7");
	}

	dragEnd(e) {
		$(document).off(".wdrag");
		this.w.css("opacity", "1");
	}

	drag(e) {
		let diffX = e.clientX-this.startMouseX;
		let diffY = e.clientY-this.startMouseY;
		this.x = this.startX + diffX;
		this.y = this.startY + diffY;
		this.position();
	}

	close() {
		if (typeof this.closeCallback === "function") this.closeCallback(this);
		this.w.remove();
		this.closed = true;
	}

	focus() {
	}
}
